(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iconos-confianza"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBeneficios(seccion) {
      var track = seccion.querySelector('[data-beneficios-iconos-track]');
      var puntosWrap = seccion.querySelector('[data-beneficios-iconos-puntos]');
      if (!track || !puntosWrap) return;

      var slides = track.querySelectorAll('[data-beneficios-iconos-slide]');
      var puntos = puntosWrap.querySelectorAll('[data-beneficios-iconos-punto]');
      if (!slides.length || !puntos.length) return;

      var mql = window.matchMedia('(min-width: 990px)');
      var indiceActual = 0;
      var ticking = false;

      function setActivo(indice) {
        if (indice === indiceActual) return;
        indiceActual = indice;
        for (var i = 0; i < puntos.length; i++) {
          if (i === indice) {
            puntos[i].classList.add('beneficios-iconos-punto--activo');
          } else {
            puntos[i].classList.remove('beneficios-iconos-punto--activo');
          }
        }
      }

      function calcularIndice() {
        var centro = track.scrollLeft + (track.clientWidth / 2);
        var masCercano = 0;
        var menorDistancia = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var slideCentro = slides[i].offsetLeft + (slides[i].offsetWidth / 2);
          var distancia = Math.abs(slideCentro - centro);
          if (distancia < menorDistancia) {
            menorDistancia = distancia;
            masCercano = i;
          }
        }
        setActivo(masCercano);
      }

      function onScroll() {
        if (mql.matches) return;
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          calcularIndice();
          ticking = false;
        });
      }

      function irA(indice) {
        var slide = slides[indice];
        if (!slide) return;
        var destino = slide.offsetLeft - ((track.clientWidth - slide.offsetWidth) / 2);
        track.scrollTo({ left: destino, behavior: 'smooth' });
      }

      track.addEventListener('scroll', onScroll, { passive: true });

      for (var i = 0; i < puntos.length; i++) {
        (function (indice) {
          puntos[indice].addEventListener('click', function () {
            irA(indice);
          });
        })(i);
      }

      calcularIndice();
    }

    function initTodos() {
      var secciones = document.querySelectorAll('[data-beneficios-iconos]');
      for (var i = 0; i < secciones.length; i++) {
        initBeneficios(secciones[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTodos);
    } else {
      initTodos();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      var seccion = evento.target.querySelector('[data-beneficios-iconos]');
      if (seccion) initBeneficios(seccion);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prueba-moonkie"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBannersPromo(seccion) {
      var track = seccion.querySelector('[data-banners-promo-track]');
      var puntosWrap = seccion.querySelector('[data-banners-promo-puntos]');
      if (!track || !puntosWrap) return;

      var slides = track.querySelectorAll('[data-banners-promo-slide]');
      var puntos = puntosWrap.querySelectorAll('[data-banners-promo-punto]');
      if (!slides.length || !puntos.length) return;

      var mql = window.matchMedia('(min-width: 990px)');
      var indiceActual = 0;
      var ticking = false;

      function setActivo(indice) {
        if (indice === indiceActual) return;
        indiceActual = indice;
        for (var i = 0; i < puntos.length; i++) {
          if (i === indice) {
            puntos[i].classList.add('banners-promo-punto--activo');
          } else {
            puntos[i].classList.remove('banners-promo-punto--activo');
          }
        }
      }

      function calcularIndice() {
        var centro = track.scrollLeft + (track.clientWidth / 2);
        var masCercano = 0;
        var menorDistancia = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var slideCentro = slides[i].offsetLeft + (slides[i].offsetWidth / 2);
          var distancia = Math.abs(slideCentro - centro);
          if (distancia < menorDistancia) {
            menorDistancia = distancia;
            masCercano = i;
          }
        }
        setActivo(masCercano);
      }

      function onScroll() {
        if (mql.matches) return;
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          calcularIndice();
          ticking = false;
        });
      }

      function irA(indice) {
        var slide = slides[indice];
        if (!slide) return;
        var destino = slide.offsetLeft - ((track.clientWidth - slide.offsetWidth) / 2);
        track.scrollTo({ left: destino, behavior: 'smooth' });
      }

      track.addEventListener('scroll', onScroll, { passive: true });

      for (var i = 0; i < puntos.length; i++) {
        (function (indice) {
          puntos[indice].addEventListener('click', function () {
            irA(indice);
          });
        })(i);
      }

      calcularIndice();
    }

    function initTodos() {
      var secciones = document.querySelectorAll('[data-banners-promo]');
      for (var i = 0; i < secciones.length; i++) {
        initBannersPromo(secciones[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTodos);
    } else {
      initTodos();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      var seccion = evento.target.querySelector('[data-banners-promo]');
      if (seccion) initBannersPromo(seccion);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
